export default __webpack_public_path__ + "img/7f221ef9f18bf5277a690d68bd03f04b.svg";